import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  attendancePath,
  clearAttendanceSession,
  continueAttendanceSession,
  readAttendanceSession,
} from './session';
import { readAttendancePolicy, RESTRICTION_MESSAGE } from './access';
import useCurrentCompanyId from '../useCurrentCompanyId';

export default function useAttendance(loadId, kind, { enforceAccess = false } = {}) {
  const companyId = useCurrentCompanyId();
  const location = useLocation();
  const navigate = useNavigate();
  const { record, error } = useMemo(
    () =>
      companyId === null
        ? { record: null, error: null }
        : readAttendanceSession(location.search, loadId, companyId, kind),
    [location.search, loadId, companyId, kind],
  );
  const [policy, setPolicy] = useState(null);
  useEffect(() => {
    if (!enforceAccess || companyId === null) return undefined;
    let active = true;
    setPolicy(null);
    readAttendancePolicy(companyId).then(
      (value) => {
        if (active) setPolicy({ companyId, value });
      },
      (failure) => {
        if (active) setPolicy({ companyId, error: failure.message });
      },
    );
    return () => {
      active = false;
    };
  }, [enforceAccess, companyId]);
  const accessPending = enforceAccess && (!policy || policy.companyId !== companyId);
  const accessError =
    enforceAccess && !accessPending
      ? policy.error ||
        (policy.value.requiresControlTowerContext && !record ? RESTRICTION_MESSAGE : null)
      : null;
  const back = () => {
    clearAttendanceSession(record);
    navigate(record?.returnTo || '/kanban-cargas', { state: record?.returnState });
  };
  // 5722: atendimento salvo segue para o registro criado; voltar ao Kanban fica só no Cancelar.
  const finish = (path) => {
    clearAttendanceSession(record);
    navigate(path, { replace: true });
  };
  // 5724: a pré-carga completada segue para a carga com o contexto novo, sem passar pelo Kanban.
  const proceed = (next, path) => {
    const following = continueAttendanceSession(record, next);
    navigate(attendancePath(path, following), { replace: true });
  };
  return {
    record,
    error: error || accessError,
    accessPending,
    requiresControlTowerContext: policy?.value?.requiresControlTowerContext,
    back,
    finish,
    proceed,
    path: (path) => attendancePath(path, record),
  };
}
